import { HttpResponse } from '@angular/common/http';
import { RequestOptions } from '@app/types';
import { Request } from '@backend/requests/request';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class InvestmentPlanDeleteRequest extends Request<never, void> {
  constructor(options?: RequestOptions<never>) {
    super({
      ...options,
      method: 'DELETE',
      path: `${options?.version ?? '/v2'}/users/me/investment_plans/${
        options?.pathParams?.investmentPlanIdentifier
      }/virtual`
    });
  }

  public execute(): Observable<void> {
    return super.execute().pipe(map((response: HttpResponse<any>) => response.body));
  }
}

export function deleteInvestmentPlan(options?: RequestOptions<never>): InvestmentPlanDeleteRequest {
  return new InvestmentPlanDeleteRequest(options);
}
